var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTabSearchLicence(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.401.56v3.479c-.553.298-1.057.676-1.494,1.12V.539c0-.287.252-.539.56-.539h.373c.308,0,.56.252.56.56Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.139.353v5.755c-.306.463-.551.969-.725,1.507V.353c0-.184.147-.353.352-.353.227,0,.373.169.373.353Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.106,0h-.373C.424,0,.172.252.172.539v9.336c0,.329.252.581.539.581h.394c.308,0,.56-.252.56-.56V.56C1.666.252,1.414,0,1.106,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.399.56v3.529c-.465-.26-.966-.463-1.494-.597V.56c0-.308.252-.56.56-.56h.373c.308,0,.56.252.56.56Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.159.374v2.975c-.245-.032-.494-.049-.747-.051V.374c0-.205.169-.374.374-.374s.373.169.373.374Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87.374v4.855c-.231-.241-.481-.464-.747-.666V.374c0-.205.168-.374.373-.374s.374.169.374.374Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.34.374v7.383c-.172-.578-.425-1.12-.747-1.614V.374c0-.205.168-.374.373-.374s.373.169.373.374Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.454,0c-.205,0-.373.168-.373.373v9.71c0,.205.168.373.373.373s.373-.168.373-.373V.374C15.828.168,15.66,0,15.454,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.641.56v2.778c-.52.058-1.021.181-1.494.361V.56c0-.308.252-.56.56-.56h.373c.308,0,.56.252.56.56Z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.704,9.449c0-2.013,1.632-3.644,3.644-3.644s3.644,1.632,3.644,3.644-1.632,3.644-3.644,3.644-3.644-1.632-3.644-3.644ZM8.348,4.348c-2.818,0-5.102,2.284-5.102,5.102s2.284,5.102,5.102,5.102c1.104,0,2.178-.358,3.061-1.02.021.028.043.054.068.078l2.186,2.186c.29.28.751.272,1.031-.018.273-.282.273-.73,0-1.013l-2.186-2.186c-.024-.024-.05-.047-.078-.068,1.691-2.254,1.234-5.452-1.02-7.143-.883-.662-1.957-1.02-3.061-1.02Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTabSearchLicence);
export default __webpack_public_path__ + "static/media/icon_tab_search-licence.4c601aa90164dfda143104a3ab19ea49.svg";
export { ForwardRef as ReactComponent };